const SESSION_ENDED = 'Your secure session ended. Sign in again to continue.';
const SERVICE_UNAVAILABLE = 'The service is temporarily unavailable. Please try again in a moment.';

function readableDetail(value) {
  if (typeof value !== 'string') return '';
  const detail = value.replace(/\s+/g, ' ').trim();
  if (!detail || detail.length > 240 || /[<>\n\r]|(?:exception|stack trace|sqlstate|cloudflare|bad gateway|request failed with|operations api returned|internal server error|^\d{3}\b)/i.test(detail)) return '';
  return detail;
}

export function isExpectedHttpFailure(status) {
  return [400, 401, 403, 404, 409, 422, 429].includes(Number(status));
}

export function explainHttpFailure({ status, code, error, message, method } = {}) {
  const httpStatus = Number(status || 0);
  const errorCode = String(code || '').toLowerCase();
  const detail = readableDetail(error || message);
  const isWrite = !['GET', 'HEAD', 'OPTIONS'].includes(String(method || 'GET').toUpperCase());

  if (errorCode === 'otp_expired') return 'This sign-in link expired or was already used. Sign in with your password or request a new link.';
  if (httpStatus === 401) return SESSION_ENDED;
  if (httpStatus === 403) return 'Your account does not have access to this action. Ask an administrator to check your permissions.';
  if (httpStatus === 400 || httpStatus === 422) return detail || 'Check the information you entered and try again.';
  if (httpStatus === 404) return 'This record could not be found. It may have been moved or removed; refresh the list and try again.';
  if (httpStatus === 409) return detail || 'This record changed while you were working. Refresh it and review your changes before saving again.';
  if (httpStatus === 429) return 'Too many requests were made in a short time. Wait a few minutes, then try again.';
  if (httpStatus === 408 || httpStatus === 504) return isWrite
    ? 'The request timed out, so we could not confirm whether your change was saved. Check the record before trying again.'
    : 'The request took too long. Check your connection and try again.';
  if (httpStatus >= 500) return isWrite
    ? 'The service had a temporary problem, so we could not confirm whether your change was saved. Check the record before trying again.'
    : SERVICE_UNAVAILABLE;
  return detail || 'We could not complete that request. Please try again.';
}

export function explainNetworkFailure(error, method = 'GET') {
  if (error?.name === 'AbortError') return error;
  const isWrite = !['GET', 'HEAD', 'OPTIONS'].includes(String(method).toUpperCase());
  const timedOut = error?.code === 'RP_REQUEST_TIMEOUT' || /timed out/i.test(String(error?.message || ''));
  const message = timedOut
    ? (isWrite ? 'The request timed out, so we could not confirm whether your change was saved. Check the record before trying again.' : 'The request took too long. Check your connection and try again.')
    : (isWrite ? 'The connection was interrupted. Check whether your change was saved before trying again.' : 'Could not connect to the service. Check your connection and try again.');
  return Object.assign(new Error(message, { cause: error }), { code: timedOut ? 'RP_REQUEST_TIMEOUT' : 'RP_NETWORK_ERROR' });
}
